import { Banner, CTA, HorizontalWordLoop } from '@/components'
import animation from '../../assets/animations/astronaut.json'
import { Fade, JackInTheBox } from "react-awesome-reveal";
import { RootState, store } from '@/store/store';
import { useSelector } from 'react-redux';
import { getStorageImagePath } from '@/utils/utils';
import { ServiceSection } from '@/components/ServiceSection';
import { FAQSection } from '@/components/FaqSection';
import { SeoTags } from '@/components/SeoTags';


export const TailoredSoftwareSolutions = () => {

    const appConfig = useSelector((state: RootState) => state.app.config);
    const page = appConfig?.services?.find(service => service?.key == 'tailored-solutions')
    if (!page) return;

    return <>

        <SeoTags
            page={page}
            pageType={"service"}
            seo_settings={store.getState().app.config.seo_settings}
        />


        <JackInTheBox triggerOnce={true} delay={1000}>
            <Banner
                subtitle={page.banner_intro_text}
                title={page.banner_title}
                image={getStorageImagePath(page.banner_image)}
                description={page?.banner_description}
            />
        </JackInTheBox>
        <Fade triggerOnce={true} delay={100}>
            <HorizontalWordLoop title={page.looping_text} />
        </Fade>

        <ServiceSection
            lottie={animation}
            title={page?.section_title}
            content={page?.section_content}
        />


        <FAQSection
            title={page?.faq_title}
            subtitle={page?.faq_subtitle}
            items={page?.faqItems}
        />


        <CTA
            title={page.cta_title}
            ctaText={page.cta_button_text}
            description={page.cta_description}
        />
    </>

}